export default function (initialDataInteractor, batchData) {
  // console.log(batchData);
  initialDataInteractor.data.questionnaire_instance_batches.push(batchData);
}